import { Alert } from '@project-minerva/design-system'
import { DataTestId } from '@project-minerva/typings'
import { FormattedMessage } from 'react-intl'

export const ErrorMessage = ({ message, 'data-testid': dataTestId }: { message?: string } & DataTestId) => (
  <Alert severity="error" data-testid={dataTestId}>
    {message ?? <FormattedMessage id="unknown-error" defaultMessage="Unknown error" />}
  </Alert>
)
